import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const textEditor = css`
	position: relative;

	.ql-toolbar {
		border: none !important;
		padding: 0 !important;
	}

	.toolbarContainer {
		display: flex;
		justify-content: space-between;
		background-color: ${colors.background};
		padding: 8px 16px;

		.toolbar {
			display: flex;
			align-items: center;
		}

		.info {
			font-size: 14px;
			display: flex;
			align-items: center;
			font-weight: 600;
			color: ${colors.secondaryText};
		}
	}

	.ql-container {
		border-bottom-right-radius: 4px;
		border-bottom-left-radius: 4px;
		border: 1px solid ${colors.background} !important;
		border-top: none !important;
		font-size: 15px;
	}

	.ql-editor h1,
	.ql-editor h2,
	.ql-editor h3,
	.ql-editor h4,
	.ql-editor p {
		margin-bottom: 10px;
	}

	.ql-rolloverText {
		display: flex !important;
		align-items: center;
		white-space: nowrap;
		width: 100%;
	}

	.eyebrow-heading {
		letter-spacing: 3px;
		text-transform: uppercase;
		margin-bottom: 10px;
		font-size: 1em !important;
	}

	.disabledToolbar {
		pointer-events: none;
	}

	.codeMode {
		margin-right: 15px;

		:hover {
			color: #06c;
			cursor: pointer;
		}
	}

	.CodeMirror {
		height: auto;
		border: 1px solid ${colors.background};
		border-top: none;
		font-size: 12px;
	}

	.CodeMirror-sizer {
		margin-left: 54px !important;
	}

	.hidden {
		display: none;
	}

	.toolbarDisabled {
		pointer-events: none;
		opacity: 0.3;
	}
`;
